import React from 'react';

import useDownloadReportForm from '../../hooks/useDownloadReportForm';

import Typography from '../../../_ui/Typography/Typography';
import CheckboxGroup from '../../../_ui/Form/CheckboxGroup/CheckboxGroup';

type UseDownloadReportFormReturnType = ReturnType<typeof useDownloadReportForm>;

export const selectableApplications = [
    {
        label: 'Hub',
        value: 2,
        name: 'applications[]',
    },
    {
        label: 'IPM',
        value: 3,
        name: 'applications[]',
    },
    {
        label: 'Sub Contractor',
        value: 4,
        name: 'applications[]',
    },
];

interface Props extends Pick<UseDownloadReportFormReturnType, 'formData' | 'setFormData'> {
    errorMessage?: string;
}

export default function ApplicationsSelector({ formData, setFormData, errorMessage }: Props) {
    const setApplication = (_checked: boolean, value: string | number) => {
        setFormData({
            ...formData,
            applications: formData.applications.includes(value as number)
                ? formData.applications.filter((application) => (
                    application !== value
                ))
                : [...formData.applications, value as number],
        });
    }

    return (
        <div className="space-y-025">
            <CheckboxGroup
                title="Applications"
                options={selectableApplications}
                checkedValues={formData.applications}
                onChange={setApplication}
            />
            {errorMessage
                ? <Typography as="div" variant="meta" color="error">{errorMessage}</Typography>
                : null}
        </div>
    );
};
